import { Header } from "../../pages/components/header";
import { RegistrySection } from "./components/registry-section";

export const Main = () => {
  return (
    <>
      <Header />
      <RegistrySection />
    </>
  );
};
